// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Aba-z","narrowOptionButtons":"Bba-z","noOptions":"Cba-z"};